import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import i18n from 'i18n-js';
import { listSx, listItemSx, listTextSx, resumeSx, totalSx, buttonSx } from './InvoiceItems.styled';
import { Card } from 'components/UI';
import Loading from 'components/Loading';
import { useSelector } from 'react-redux';
import { formatAmount } from 'utils';
import { buildUrl } from 'utils';

const InvoicePayments = ({ id }) => {
  const history = useHistory();

  const { invoice, loading } = useSelector((state) => state.invoice);

  const payments = invoice?.payments;

  const total_paid =
    invoice?.payments?.reduce((accumulator, payment) => accumulator + payment.charge_amount, 0) ||
    0;

  const paymentResume = [
    {
      label: i18n.t('invoice.paid_with_credits'),
      value: `$${formatAmount(invoice?.paid_credit)}`,
    },
    {
      label: i18n.t('invoice.total_preauth'),
      value: `$${formatAmount(invoice?.pre_auth)}`,
    },
    {
      label: i18n.t('invoice.total_paid'),
      value: `$${formatAmount(total_paid)}`,
      sx: totalSx,
    },
  ];

  return (
    <Card
      title={
        <Grid container alignItems="center" justifyContent="space-between">
          <span>{i18n.t('invoice.payment')}</span>
          <Button
            type="button"
            variant="text"
            color="primary"
            disableFocusRipple={true}
            sx={buttonSx}
            data-cy="view-all-payments"
            onClick={() =>
              history.push({
                pathname: buildUrl('/payments'),
                state: {
                  invoice_id: id,
                  sort_field: 'modified_time',
                  sort_desc: true,
                },
              })
            }
          >
            {i18n.t('invoice.view_all')}
          </Button>
        </Grid>
      }
      headerActionType="vertical"
      datacy="invoice-payment-widget"
    >
      <Box>
        {loading ? (
          <Box>
            <Loading />
          </Box>
        ) : (
          <>
            {payments?.length > 0 ? (
              <>
                <Box
                  style={{
                    height: '100%',
                    maxHeight: 'calc(100% - 52px)',
                    minHeight: 150,
                    overflowY: 'auto',
                  }}
                >
                  <List sx={[listSx, resumeSx]}>
                    {paymentResume.map((info, index) => (
                      <ListItem key={index} sx={listItemSx}>
                        <ListItemText
                          primary={info.label}
                          secondary={
                            <Typography
                              variant="body2"
                              component="span"
                              color="textSecondary"
                              sx={info.sx}
                            >
                              {info.value}
                            </Typography>
                          }
                          sx={listTextSx}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </>
            ) : (
              <Typography variant="h4">
                <Box fontSize={14}>{i18n.t('common.empty_list')}</Box>
              </Typography>
            )}
          </>
        )}
      </Box>
    </Card>
  );
};

InvoicePayments.propTypes = {
  id: PropTypes.any,
};

export { InvoicePayments };
